/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthedRouteImport } from './routes/_authed';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AuthedHermesRouteImport } from './routes/_authed/hermes';
import { Route as AuthedReviewRouteImport } from './routes/_authed/review';
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings';
import { Route as AuthedTodayRouteImport } from './routes/_authed/today';
import { Route as AuthedContactsIndexRouteImport } from './routes/_authed/contacts/index';
import { Route as AuthedContactsContactIdRouteImport } from './routes/_authed/contacts/$contactId';
import { Route as AuthedContactsNewRouteImport } from './routes/_authed/contacts/new';
import { Route as AuthedEventsIndexRouteImport } from './routes/_authed/events/index';
import { Route as AuthedEventsEventIdRouteImport } from './routes/_authed/events/$eventId';
import { Route as AuthedListsIndexRouteImport } from './routes/_authed/lists/index';
import { Route as AuthedListsListIdRouteImport } from './routes/_authed/lists/$listId';
import { Route as AuthedMeetingsMeetingIdRouteImport } from './routes/_authed/meetings/$meetingId';
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed/settings/index';
import { Route as AuthedSettingsAccountsRouteImport } from './routes/_authed/settings/accounts';
import { Route as AuthedSettingsDevicesRouteImport } from './routes/_authed/settings/devices';
import { Route as AuthedSettingsOrganizationRouteImport } from './routes/_authed/settings/organization';
import { Route as AuthedSettingsPrivacyRouteImport } from './routes/_authed/settings/privacy';
import { Route as AuthedSettingsProfileRouteImport } from './routes/_authed/settings/profile';
import { Route as AuthedSettingsSharingRouteImport } from './routes/_authed/settings/sharing';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedHermesRoute = AuthedHermesRouteImport.update({
  id: '/hermes',
  path: '/hermes',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedReviewRoute = AuthedReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedTodayRoute = AuthedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedContactsIndexRoute = AuthedContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedContactsContactIdRoute = AuthedContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedContactsNewRoute = AuthedContactsNewRouteImport.update({
  id: '/contacts/new',
  path: '/contacts/new',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedEventsIndexRoute = AuthedEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedEventsEventIdRoute = AuthedEventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedListsIndexRoute = AuthedListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedListsListIdRoute = AuthedListsListIdRouteImport.update({
  id: '/lists/$listId',
  path: '/lists/$listId',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedMeetingsMeetingIdRoute = AuthedMeetingsMeetingIdRouteImport.update({
  id: '/meetings/$meetingId',
  path: '/meetings/$meetingId',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSettingsRoute,
} as any);
const AuthedSettingsAccountsRoute = AuthedSettingsAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthedSettingsRoute,
} as any);
const AuthedSettingsDevicesRoute = AuthedSettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedSettingsRoute,
} as any);
const AuthedSettingsOrganizationRoute =
  AuthedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthedSettingsRoute,
  } as any);
const AuthedSettingsPrivacyRoute = AuthedSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AuthedSettingsRoute,
} as any);
const AuthedSettingsProfileRoute = AuthedSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedSettingsRoute,
} as any);
const AuthedSettingsSharingRoute = AuthedSettingsSharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => AuthedSettingsRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/hermes': typeof AuthedHermesRoute;
  '/review': typeof AuthedReviewRoute;
  '/settings': typeof AuthedSettingsRouteWithChildren;
  '/today': typeof AuthedTodayRoute;
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute;
  '/contacts/new': typeof AuthedContactsNewRoute;
  '/events/$eventId': typeof AuthedEventsEventIdRoute;
  '/lists/$listId': typeof AuthedListsListIdRoute;
  '/meetings/$meetingId': typeof AuthedMeetingsMeetingIdRoute;
  '/settings/accounts': typeof AuthedSettingsAccountsRoute;
  '/settings/devices': typeof AuthedSettingsDevicesRoute;
  '/settings/organization': typeof AuthedSettingsOrganizationRoute;
  '/settings/privacy': typeof AuthedSettingsPrivacyRoute;
  '/settings/profile': typeof AuthedSettingsProfileRoute;
  '/settings/sharing': typeof AuthedSettingsSharingRoute;
  '/contacts/': typeof AuthedContactsIndexRoute;
  '/events/': typeof AuthedEventsIndexRoute;
  '/lists/': typeof AuthedListsIndexRoute;
  '/settings/': typeof AuthedSettingsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/hermes': typeof AuthedHermesRoute;
  '/review': typeof AuthedReviewRoute;
  '/today': typeof AuthedTodayRoute;
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute;
  '/contacts/new': typeof AuthedContactsNewRoute;
  '/events/$eventId': typeof AuthedEventsEventIdRoute;
  '/lists/$listId': typeof AuthedListsListIdRoute;
  '/meetings/$meetingId': typeof AuthedMeetingsMeetingIdRoute;
  '/settings/accounts': typeof AuthedSettingsAccountsRoute;
  '/settings/devices': typeof AuthedSettingsDevicesRoute;
  '/settings/organization': typeof AuthedSettingsOrganizationRoute;
  '/settings/privacy': typeof AuthedSettingsPrivacyRoute;
  '/settings/profile': typeof AuthedSettingsProfileRoute;
  '/settings/sharing': typeof AuthedSettingsSharingRoute;
  '/contacts': typeof AuthedContactsIndexRoute;
  '/events': typeof AuthedEventsIndexRoute;
  '/lists': typeof AuthedListsIndexRoute;
  '/settings': typeof AuthedSettingsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_authed': typeof AuthedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/_authed/hermes': typeof AuthedHermesRoute;
  '/_authed/review': typeof AuthedReviewRoute;
  '/_authed/settings': typeof AuthedSettingsRouteWithChildren;
  '/_authed/today': typeof AuthedTodayRoute;
  '/_authed/contacts/$contactId': typeof AuthedContactsContactIdRoute;
  '/_authed/contacts/new': typeof AuthedContactsNewRoute;
  '/_authed/events/$eventId': typeof AuthedEventsEventIdRoute;
  '/_authed/lists/$listId': typeof AuthedListsListIdRoute;
  '/_authed/meetings/$meetingId': typeof AuthedMeetingsMeetingIdRoute;
  '/_authed/settings/accounts': typeof AuthedSettingsAccountsRoute;
  '/_authed/settings/devices': typeof AuthedSettingsDevicesRoute;
  '/_authed/settings/organization': typeof AuthedSettingsOrganizationRoute;
  '/_authed/settings/privacy': typeof AuthedSettingsPrivacyRoute;
  '/_authed/settings/profile': typeof AuthedSettingsProfileRoute;
  '/_authed/settings/sharing': typeof AuthedSettingsSharingRoute;
  '/_authed/contacts/': typeof AuthedContactsIndexRoute;
  '/_authed/events/': typeof AuthedEventsIndexRoute;
  '/_authed/lists/': typeof AuthedListsIndexRoute;
  '/_authed/settings/': typeof AuthedSettingsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/hermes'
    | '/review'
    | '/settings'
    | '/today'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/events/$eventId'
    | '/lists/$listId'
    | '/meetings/$meetingId'
    | '/settings/accounts'
    | '/settings/devices'
    | '/settings/organization'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/sharing'
    | '/contacts/'
    | '/events/'
    | '/lists/'
    | '/settings/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/hermes'
    | '/review'
    | '/today'
    | '/contacts/$contactId'
    | '/contacts/new'
    | '/events/$eventId'
    | '/lists/$listId'
    | '/meetings/$meetingId'
    | '/settings/accounts'
    | '/settings/devices'
    | '/settings/organization'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/sharing'
    | '/contacts'
    | '/events'
    | '/lists'
    | '/settings';
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/hermes'
    | '/_authed/review'
    | '/_authed/settings'
    | '/_authed/today'
    | '/_authed/contacts/$contactId'
    | '/_authed/contacts/new'
    | '/_authed/events/$eventId'
    | '/_authed/lists/$listId'
    | '/_authed/meetings/$meetingId'
    | '/_authed/settings/accounts'
    | '/_authed/settings/devices'
    | '/_authed/settings/organization'
    | '/_authed/settings/privacy'
    | '/_authed/settings/profile'
    | '/_authed/settings/sharing'
    | '/_authed/contacts/'
    | '/_authed/events/'
    | '/_authed/lists/'
    | '/_authed/settings/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/hermes': {
      id: '/_authed/hermes';
      path: '/hermes';
      fullPath: '/hermes';
      preLoaderRoute: typeof AuthedHermesRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/review': {
      id: '/_authed/review';
      path: '/review';
      fullPath: '/review';
      preLoaderRoute: typeof AuthedReviewRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/settings': {
      id: '/_authed/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthedSettingsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/today': {
      id: '/_authed/today';
      path: '/today';
      fullPath: '/today';
      preLoaderRoute: typeof AuthedTodayRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/contacts/': {
      id: '/_authed/contacts/';
      path: '/contacts';
      fullPath: '/contacts/';
      preLoaderRoute: typeof AuthedContactsIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/contacts/$contactId': {
      id: '/_authed/contacts/$contactId';
      path: '/contacts/$contactId';
      fullPath: '/contacts/$contactId';
      preLoaderRoute: typeof AuthedContactsContactIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/contacts/new': {
      id: '/_authed/contacts/new';
      path: '/contacts/new';
      fullPath: '/contacts/new';
      preLoaderRoute: typeof AuthedContactsNewRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/events/': {
      id: '/_authed/events/';
      path: '/events';
      fullPath: '/events/';
      preLoaderRoute: typeof AuthedEventsIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/events/$eventId': {
      id: '/_authed/events/$eventId';
      path: '/events/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof AuthedEventsEventIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/lists/': {
      id: '/_authed/lists/';
      path: '/lists';
      fullPath: '/lists/';
      preLoaderRoute: typeof AuthedListsIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/lists/$listId': {
      id: '/_authed/lists/$listId';
      path: '/lists/$listId';
      fullPath: '/lists/$listId';
      preLoaderRoute: typeof AuthedListsListIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/meetings/$meetingId': {
      id: '/_authed/meetings/$meetingId';
      path: '/meetings/$meetingId';
      fullPath: '/meetings/$meetingId';
      preLoaderRoute: typeof AuthedMeetingsMeetingIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/settings/': {
      id: '/_authed/settings/';
      path: '/';
      fullPath: '/settings/';
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/accounts': {
      id: '/_authed/settings/accounts';
      path: '/accounts';
      fullPath: '/settings/accounts';
      preLoaderRoute: typeof AuthedSettingsAccountsRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/devices': {
      id: '/_authed/settings/devices';
      path: '/devices';
      fullPath: '/settings/devices';
      preLoaderRoute: typeof AuthedSettingsDevicesRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/organization': {
      id: '/_authed/settings/organization';
      path: '/organization';
      fullPath: '/settings/organization';
      preLoaderRoute: typeof AuthedSettingsOrganizationRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/privacy': {
      id: '/_authed/settings/privacy';
      path: '/privacy';
      fullPath: '/settings/privacy';
      preLoaderRoute: typeof AuthedSettingsPrivacyRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/profile': {
      id: '/_authed/settings/profile';
      path: '/profile';
      fullPath: '/settings/profile';
      preLoaderRoute: typeof AuthedSettingsProfileRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
    '/_authed/settings/sharing': {
      id: '/_authed/settings/sharing';
      path: '/sharing';
      fullPath: '/settings/sharing';
      preLoaderRoute: typeof AuthedSettingsSharingRouteImport;
      parentRoute: typeof AuthedSettingsRoute;
    };
  }
}

interface AuthedSettingsRouteChildren {
  AuthedSettingsAccountsRoute: typeof AuthedSettingsAccountsRoute;
  AuthedSettingsDevicesRoute: typeof AuthedSettingsDevicesRoute;
  AuthedSettingsOrganizationRoute: typeof AuthedSettingsOrganizationRoute;
  AuthedSettingsPrivacyRoute: typeof AuthedSettingsPrivacyRoute;
  AuthedSettingsProfileRoute: typeof AuthedSettingsProfileRoute;
  AuthedSettingsSharingRoute: typeof AuthedSettingsSharingRoute;
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute;
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsAccountsRoute: AuthedSettingsAccountsRoute,
  AuthedSettingsDevicesRoute: AuthedSettingsDevicesRoute,
  AuthedSettingsOrganizationRoute: AuthedSettingsOrganizationRoute,
  AuthedSettingsPrivacyRoute: AuthedSettingsPrivacyRoute,
  AuthedSettingsProfileRoute: AuthedSettingsProfileRoute,
  AuthedSettingsSharingRoute: AuthedSettingsSharingRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
};

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
);

interface AuthedRouteChildren {
  AuthedHermesRoute: typeof AuthedHermesRoute;
  AuthedReviewRoute: typeof AuthedReviewRoute;
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren;
  AuthedTodayRoute: typeof AuthedTodayRoute;
  AuthedContactsContactIdRoute: typeof AuthedContactsContactIdRoute;
  AuthedContactsNewRoute: typeof AuthedContactsNewRoute;
  AuthedEventsEventIdRoute: typeof AuthedEventsEventIdRoute;
  AuthedListsListIdRoute: typeof AuthedListsListIdRoute;
  AuthedMeetingsMeetingIdRoute: typeof AuthedMeetingsMeetingIdRoute;
  AuthedContactsIndexRoute: typeof AuthedContactsIndexRoute;
  AuthedEventsIndexRoute: typeof AuthedEventsIndexRoute;
  AuthedListsIndexRoute: typeof AuthedListsIndexRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedHermesRoute: AuthedHermesRoute,
  AuthedReviewRoute: AuthedReviewRoute,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedTodayRoute: AuthedTodayRoute,
  AuthedContactsContactIdRoute: AuthedContactsContactIdRoute,
  AuthedContactsNewRoute: AuthedContactsNewRoute,
  AuthedEventsEventIdRoute: AuthedEventsEventIdRoute,
  AuthedListsListIdRoute: AuthedListsListIdRoute,
  AuthedMeetingsMeetingIdRoute: AuthedMeetingsMeetingIdRoute,
  AuthedContactsIndexRoute: AuthedContactsIndexRoute,
  AuthedEventsIndexRoute: AuthedEventsIndexRoute,
  AuthedListsIndexRoute: AuthedListsIndexRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
